import React from "react";

// Top-level error boundary. Catches render-time exceptions inside its subtree
// so a single null-read in one route doesn't take the whole site to a white
// screen. Each <Routes> child is wrapped individually in Main.js, and the
// whole app is wrapped again in App.js as a last-resort safety net.
class ErrorBoundary extends React.Component {
  state = {error: null};

  static getDerivedStateFromError(error) {
    return {error};
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info?.componentStack);
  }

  handleReset = () => {
    this.setState({error: null});
  };

  render() {
    if (!this.state.error) return this.props.children;

    if (typeof this.props.fallback === "function") {
      return this.props.fallback(this.state.error, this.handleReset);
    }

    return (
      <div className="rd-fatal" role="alert" style={{
        padding: "48px 24px",
        textAlign: "center",
        maxWidth: 560,
        margin: "0 auto",
      }}>
        <h2 style={{marginBottom: 8}}>Something went wrong.</h2>
        <p style={{opacity: 0.75, marginBottom: 20}}>
          We've logged the error. You can try the page again, or head back to the homepage.
        </p>
        <div style={{display: "flex", gap: 10, justifyContent: "center"}}>
          <button type="button" onClick={this.handleReset} className="rdf-button">
            Try again
          </button>
          <a href="/" className="rdf-button" style={{textDecoration: "none"}}>
            Go home
          </a>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
